import api from "./api"

export const getTemplates = async (params = {}) => {
  try {
    const response = await api.get("/email-settings/templates", { params })
    return response.data
  } catch (error) {
    console.error("Error fetching email templates:", error)
    return {
      success: false,
      error: error.response?.data?.error || "Failed to fetch email templates",
    }
  }
}

export const updateTemplate = async (templateId, templateData, params = {}) => {
  try {
    const response = await api.put(`/email-settings/templates/${templateId}`, templateData, { params })
    return response.data
  } catch (error) {
    console.error("Error updating email template:", error)
    return {
      success: false,
      error: error.response?.data?.error || "Failed to update email template",
    }
  }
}

export const resetTemplate = async (templateId, params = {}) => {
  try {
    const response = await api.post(`/email-settings/templates/${templateId}/reset`, {}, { params })
    return response.data
  } catch (error) {
    console.error("Error resetting email template:", error)
    return {
      success: false,
      error: error.response?.data?.error || "Failed to reset email template",
    }
  }
}

export const sendTestEmail = async (email, templateId, params = {}) => {
  try {
    const response = await api.post(
      `/email-settings/send-test`,
      {
        email,
        templateId,
      },
      { params },
    )
    return response.data
  } catch (error) {
    console.error("Error sending test email:", error)
    return {
      success: false,
      error: error.response?.data?.error || "Failed to send test email",
    }
  }
}

